document.addEventListener("DOMContentLoaded", function () {
  const suchfeld = document.getElementById("ds-needs-search");
  const items = document.querySelectorAll(".ds-needs-blocks .ds-needs__item");

  suchfeld.addEventListener("keyup", function () {
    const suchwert = suchfeld.value.toLowerCase();
    items.forEach(function (item) {
      if (item.textContent.toLowerCase().includes(suchwert)) {
        item.style.display = "";
      } else {
        item.style.display = "none";
      }
    });
  });
});